import React from "react";
import styled from "styled-components";
import { useTable } from "react-table";

interface Props {
  data: any[];
  columns: any[];
}

export const RevenueTable = ({ ...props }: Props) => {
  const { data, columns } = props;

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable({
    columns,
    data,
  });

  if (!data.length) {
    return <></>;
  }

  return (
    <Styled>
      <table {...getTableProps()}>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th {...column.getHeaderProps()}>{column.render("Header")}</th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.map((row, i) => {
            prepareRow(row);
            return row.values["amount"] ? (
              <tr
                {...row.getRowProps()}
                key={`RevenueTableRow|${i}`}
                className="hasAmount"
              >
                {row.cells.map((cell) => {
                  return (
                    <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                  );
                })}
              </tr>
            ) : (
              <tr {...row.getRowProps()} key={`RevenueTableRow|${i}`}>
                {row.cells.map((cell) => {
                  return (
                    <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </Styled>
  );
};

const Styled = styled.div`
  table {
    width: 100%;
    font-size: 12px;
    border-collapse: collapse;
  }
  table th {
    text-align: left;
    font-weight: 400;
    padding: 12px 2px 4px;
    border-bottom: 1px solid #000000;
  }
  table th:nth-child(3) {
    min-width: 36px;
  }
  table th:nth-child(4) {
    min-width: 36px;
  }
  table th:last-child {
    min-width: 50px;
  }
  table tr.hasAmount {
    border-bottom: 1px solid #000000;
  }
  table td {
    text-align: left;
    padding: 10px 4px;
    // border-bottom: 1px solid #000000;
  }
`;

export default RevenueTable;
